import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { Container, Card, Row, Col, Table, Button } from "react-bootstrap";
import { API_URL } from "..";


const PayrollPreview = () => {
  const { emp_id , month, year} = useParams();
  const [payrollData, setPayrollData] = useState(null);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [companyInfo] = useState({
    name: user?.business_name || "TowRankers Inc.",
    logo: user?.business_logo ? API_URL + user.business_logo : "https://via.placeholder.com/150x50?text=Logo",
    address: user?.address || "123 Business Street, City, Country",
    email: user?.email || "contact@towrankers.com",
    phone: user?.phone || "+1 (123) 456-7890",
  });

  useEffect(() => {
    fetchPayrollData();
  }, [emp_id]);

  const fetchPayrollData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/payroll/generate-single`, {
        method: "POST",
        body: JSON.stringify({
          emp_id: emp_id,
          month: month,
          year: year,
        }),
        headers: { Accept: "*/*", "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (response.status === 200) {
        setPayrollData(data.payroll);
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error);
    }
  };

  const handlePrint = () => {
    // Create print template with the same layout and styling
    const printTemplate = `
      <html>
        <head>
          <title>Payroll Slip</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .container { max-width: 800px; margin: auto; }
            .card-body { padding: 2rem; }
            .logo { max-width: 150px; }
            .table-sm th, .table-sm td { padding: 0.5rem; font-size: 0.9rem; }
            h6 { font-size: 1.1rem; margin-bottom: 1rem; }
            .text-end { text-align: right; }
            .mb-4 { margin-bottom: 1.5rem; }
            .mt-4 { margin-top: 1.5rem; }
            .mt-3 { margin-top: 1rem; }
            hr { margin: 1.5rem 0; }
            @media print {
              body { padding: 0; }
              .container { margin: 0; }
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="card shadow-sm border-0">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-md-6" style="width:50%">
                    <img src="${companyInfo.logo}" alt="Company Logo" class="logo" />
                    <h6 class="mt-2">${companyInfo.name}</h6>
                    <p>${companyInfo.address}</p>
                    <p>Email: ${companyInfo.email}</p>
                    <p>Phone: ${companyInfo.phone}</p>
                  </div>
                  <div class="col-md-6 text-end" style="width:50%;text-align:end">
                    <h6>Payroll Slip</h6>
                    <p>Employee ID: ${payrollData.emp_id}</p>
                    <p>Payroll Period: ${payrollData.payroll_period}</p>
                    <p>Status: ${payrollData.status || "Pending"}</p>
                  </div>
                </div>
                <hr />
                <div class="row mb-4 mt-3">
                  <div class="col">
                    <h6>Employee Details</h6>
                    <p><strong>Name:</strong> ${payrollData.name}</p>
                    <p><strong>Job Title:</strong> ${payrollData.job_title}</p>
                    <p><strong>Joining Date:</strong> ${new Date(payrollData.joining_date).toLocaleDateString()}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <h6 class="mb-3">Earnings</h6>
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Basic Salary</td>
                          <td>$${parseFloat(payrollData.salary_amount).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Allowance</td>
                          <td>$${parseFloat(payrollData.allowance || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Bonuses</td>
                          <td>$${parseFloat(payrollData.bonuses || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Commission</td>
                          <td>$${parseFloat(payrollData.commission || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td><strong>Gross Salary</strong></td>
                          <td><strong>$${parseFloat(payrollData.gross_salary).toFixed(2)}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="col">
                    <h6 class="mb-3">Deductions</h6>
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th>Description</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Advance</td>
                          <td>$${parseFloat(payrollData.advance || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Loan</td>
                          <td>$${parseFloat(payrollData.loan || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Tax</td>
                          <td>$${parseFloat(payrollData.tax_amount || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Deductions</td>
                          <td>$${parseFloat(payrollData.deducted_salary || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td>Fine</td>
                          <td>$${parseFloat(payrollData.fine || 0).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <td><strong>Total Deductions</strong></td>
                          <td><strong>$${(
                            parseFloat(payrollData.advance || 0) +
                            parseFloat(payrollData.loan || 0) +
                            parseFloat(payrollData.tax_amount || 0) +
                            parseFloat(payrollData.deducted_salary || 0) +
                            parseFloat(payrollData.fine || 0)
                          ).toFixed(2)}</strong></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col text-end">
                    <h6>Net Salary: $${parseFloat(payrollData.net_salary).toFixed(2)}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </body>
      </html>
    `;

    // Create a new window for printing
    const printWindow = window.open("", "_blank");
    printWindow.document.write(printTemplate);
    printWindow.document.close();

    // Trigger print after the content is loaded
    printWindow.onload = () => {
      printWindow.print();
      printWindow.onafterprint = () => printWindow.close();
    };
  };

  if (!payrollData) return <div>Loading...</div>;

  return (
    <MasterLayout>
      <Breadcrumb title="Payroll Invoice" />
      <Container className="py-4">
        <Card className="shadow-sm border-0">
          <Card.Body className="p-5">
            <Row className="mb-4">
              <Col md={6}>
                <img src={companyInfo.logo} alt="Logo" style={{ maxWidth: "150px" }} />
                <h6 className="mt-2">{companyInfo.name}</h6>
                <p>{companyInfo.address}</p>
                <p>Email: {companyInfo.email}</p>
                <p>Phone: {companyInfo.phone}</p>
              </Col>
              <Col md={6} className="text-end">
                <h6>Payroll Slip</h6>
                <p>Employee ID: {payrollData.emp_id}</p>
                <p>Payroll Period: {payrollData.payroll_period}</p>
                <p>Status: {payrollData.status || "Pending"}</p>
              </Col>
            </Row>
            <hr />
            <Row className="mb-4 mt-3">
              <Col>
                <h6>Employee Details</h6>
                <p>
                  <strong>Name:</strong> {payrollData.name}
                </p>
                <p>
                  <strong>Job Title:</strong> {payrollData.job_title}
                </p>
                <p>
                  <strong>Joining Date:</strong>{" "}
                  {new Date(payrollData.joining_date).toLocaleDateString()}
                </p>
              </Col>
            </Row>
            <Row>
              <Col>
                <h6 className="mb-3">Earnings</h6>
                <Table bordered className="table-sm">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Basic Salary</td>
                      <td>${parseFloat(payrollData.salary_amount).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Allowance</td>
                      <td>${parseFloat(payrollData.allowance || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Bonuses</td>
                      <td>${parseFloat(payrollData.bonuses || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Commission</td>
                      <td>${parseFloat(payrollData.commission || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Gross Salary</strong>
                      </td>
                      <td>
                        <strong>${parseFloat(payrollData.gross_salary).toFixed(2)}</strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
              <Col>
                <h6 className="mb-3">Deductions</h6>
                <Table bordered className="table-sm">
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Advance</td>
                      <td>${parseFloat(payrollData.advance || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Loan</td>
                      <td>${parseFloat(payrollData.loan || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Tax</td>
                      <td>${parseFloat(payrollData.tax_amount || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Deductions</td>
                      <td>${parseFloat(payrollData.deducted_salary || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>Fine</td>
                      <td>${parseFloat(payrollData.fine || 0).toFixed(2)}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total Deductions</strong>
                      </td>
                      <td>
                        <strong>
                          ${(
                            parseFloat(payrollData.advance || 0) +
                            parseFloat(payrollData.loan || 0) +
                            parseFloat(payrollData.tax_amount || 0) +
                            parseFloat(payrollData.deducted_salary || 0) +
                            parseFloat(payrollData.fine || 0)
                          ).toFixed(2)}
                        </strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="text-end">
                <h6>Net Salary: ${parseFloat(payrollData.net_salary).toFixed(2)}</h6>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col className="text-center">
                <Button variant="primary" onClick={handlePrint}>
                  Print Invoice
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Container>
    </MasterLayout>
  );
};

export default PayrollPreview;